export default import.meta.ROLLDOWN_FILE_URL_Yc2t6BETuqA7Sc4ZKLv8pQ